const DownUp1 = [
    {id: "0", value: "以下"},    
    {id: "1", value: "以上"},
  ];  
  
  export default DownUp1